/* import req'd components and other assets (professional picture) */
import Navbar from "../components/Navbar.js"
import Hero from "../components/Hero.js"
import About from "../components/About.js"
import Beach from "../assets/BeachSquare.JPG"
import Footer from "../components/Footer.js"

const str = "Feel free to check out any of my project and literature experiences, and reach out for any collaborative inquiries!";


function Home() {


    
    return (
        <div>
            <Navbar/>

            <Hero 
                cName="hero"
                title={"Matthew P. Kearney"}
                subtitle={"Explorer. Educator. Creator of ideas."}
                url="/projects"
                btnClass={"show"}
                buttonText={"View Projects"}
            />

           <About 
           src={Beach}
           txt={"During my studies towards a B.S. in computer science, I distributed my energy within all foundational and advancing areas of the field and applied a lens based on nature, physics, and society. I hold great passion towards conversations of climate adaptation, life sciences, and all-around oceanic and environmental sciences focused on calculated and scalable benefits in our world."}

        //    txt1={"In late June, I began working at Shady Hill Greenhouses and Nursery Center in Londonderry, NH where I have been excited to learn the flow and assist with general operations across growing and irrigation operations, landscape design, and greenhouse maintenance. I'm looking for a position where I can join a well-oiled team to develop data, software, and systems solutions to create a more positive outlook for our Earth system. ${str}"}
            txt1={
            <>
                {/* <br/><br/> */}
                I am primarily motivated by purpose, mutual respect in my communities, as well as staying curious myself. On all fronts, I tend to follow my pursuits applying technology in a creative way for the Earth and its beings. 

                <br/><br/>
                I am currently looking for development and analytical work in fields with applications towards meteorology and physical modeling, environmental and life sciences, and embedded and application development. 
                <br/><br/>
                In years down the line and depending on where my interests lead me, I might enjoy gaining more education in fields related to meteorology, applied math and physics, Earth systems and environmental sciences, public policy and urban planning.
                <br/><br/>
                
                {str}
                &emsp; Thank you.
            </>
}
           />

           <Footer/>
        </div>
    )

} 

export default Home;